import React, { useEffect } from 'react';
import {
  Box,
  Card,
  ParagraphText,
  StackLayout,
  GDSStyleObject,
} from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import * as CONSTANTS from '../utils/constant';
import { DOCUMENT_CENTER_ASSET_KEYS } from '../types/document-center.types';
import { TabsComponent } from './tabs.component';
import { HeaderComponent } from './header.component';

export function LandingComponent(props: any) {
  const {
    id,
    ubkValue,
    isLoading,
    setIsLoading,
    tabActive,
    setTabActive,
    recentDocs,
    recentDocsEmpty,
    setErrMsg,
    fetchDocumentsList,
    accessToken,
    // medicareMember,
  } = props;
  const headerImage = useStaticAsset(DOCUMENT_CENTER_ASSET_KEYS.HEADER_IMAGE);

  useEffect(() => {
    if (
      tabActive === CONSTANTS.RECENT &&
      !recentDocs.length &&
      !recentDocsEmpty &&
      !id &&
      accessToken
    ) {
      fetchDocumentsList(CONSTANTS.RECENT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabActive, accessToken]);

  return (
    <Box
      css={
        {
          display: 'flex',
          flexDirection: 'column',
        } as GDSStyleObject
      }
    >
      <HeaderComponent title={CONSTANTS.DOCUMENT_CENTER} />
      <StackLayout
        orientation="horizontal"
        spacing={{ '@desktop': '$two' }}
        css={{
          display: 'block',
          width: '100%',
          maxWidth: '898px',
          margin: '$none auto',
          '@desktop': { paddingBottom: '50px' },
          '@mobile': { padding: '$none' },
          '@tablet': { paddingLeft: '25px' },
          '@mobileLandscape': { paddingLeft: '25px' } as GDSStyleObject,
        }}
      >
        <Box css={{ marginBottom: '60px' }}>
          <Box
            css={{
              margin: '24px 0 36px',
              display: 'flex',
              flexWrap: 'wrap',
              '@mobile': {
                margin: '24px 0 32px',
                padding: '0 24px',
              },
            }}
          >
            <Card.Image
              css={{
                maxWidth: '150px',
                margin: 'auto',
                '@mobile': {
                  maxWidth: '100px',
                },
              }}
              image={headerImage as string}
              imageAlt="Header Icon"
            />
            <ParagraphText
              css={{
                flex: '0 0 100%',
                marginTop: '24px',
                fontFamily: `${CONSTANTS.FONT_ROBOTO}`,
                color: '#2C3135',
                marginBottom: 0,
                fontSize: '16px',
                lineHeight: '24px',
              }}
            >
              {CONSTANTS.VIEW_YOUR_PLAN}
            </ParagraphText>
          </Box>

          <TabsComponent
            docsList={recentDocs}
            ubkValue={ubkValue}
            tabActive={tabActive}
            setTabActive={setTabActive}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setErrMsg={setErrMsg}
            accessToken={accessToken}
            // medicareMember={medicareMember}
          />
        </Box>
      </StackLayout>
    </Box>
  );
}
